export default {
  buildStats(payments) {
    const date = new Date();

    let dataset = {};
    while (Object.keys(dataset).length < 12) {
      const key = `${date.getMonth()} ${date.getFullYear()}`;
      dataset[key] = {
        sum: 0,
        sort: date.getFullYear() * 100 + date.getMonth(),
        name: [date.toLocaleString('ru-ru', { month: 'long' }), date.getFullYear()],
      };
      date.setDate(0);
    }

    payments.forEach(p => {
      const key = `${p.createdAt.getMonth()} ${p.createdAt.getFullYear()}`;
      if (dataset[key]) {
        dataset[key].sum += p.amount;
      }
    });

    dataset = Object.entries(dataset).map(([, v]) => v).sort((a, b) => a.sort - b.sort);

    const labels = dataset.map(d => d.name);
    const data = dataset.map(d => Math.round(d.sum * 0.3) / 100);

    return { labels, data };
  },
};
